import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {simpleUserSelector} from 'app/user';

/**
 * Checks whether the current user has every required permission.
 *
 * @param requiredPermissions Permissions required for the current screen.
 * @returns `true` when all permissions are present.
 *
 * @example
 * const canEdit = useCurrentUserHasAllPermissions(['USER_PROFILE', 'ADMIN']);
 */
const useCurrentUserHasAllPermissions = (requiredPermissions: Array<string>): boolean => {
    const userPermissions = useSelector(simpleUserSelector.currentUserPermissions);

    return useMemo(() =>
        // eslint-disable-next-line @fl/use-eta-reduction
        requiredPermissions.every(permission => userPermissions.includes(permission)),
    [requiredPermissions, userPermissions]);
};

export default useCurrentUserHasAllPermissions;
